import { useField } from "formik";
import { cn } from "utils/helpers";
import { FieldForm } from "components/RFQ/Input";
import { BidderQuestionnaireHeader } from "./BidderQuestionnaireHeader";

export const DropdownQuestionnaire = ({
	className,
	question,
	options,
	required,
	fieldValue,
	...props
}) => {
	const [, { error }] = useField(props);

	return (
		<div className={cn(className)}>
			<BidderQuestionnaireHeader
				question={question}
				required={required}
				error={error}
				touchedField={props?.touchedField}
				description={
					props?.rfqSubmission ? "Select one option from dropdown" : null
				}
			/>
			<div>
				<FieldForm
					type="select"
					options={fieldValue.map((item, i) => ({
						label: item,
						value: i.toString(),
					}))}
					className="my-4 w-full"
					required={required}
					name={props.name}
					disabled={props?.disabled}
				/>
			</div>
		</div>
	);
};
